// https://i.ytimg.com/vi/JtUEEwVKj4c/(default|mqdefault|hqdefault|...).jpg
export const YOUTUBE_THUMBNAIL_PATTERN = /^(?:https?:)?\/\/i\.ytimg\.com\/vi\/([^/]+)\/([^.]+)\.jpg$/;

// NOTE: `standard` and `maxres` sizes are skipped, because they may or may not exist for youtube video
const YOUTUBE_THUMBNAIL_SIZES = [{
  // Normal Quality Thumbnail
  name: 'mqdefault',
  width: 120,
  height: 90
}, {
  // Medium Quality Thumbnail
  name: 'mqdefault',
  width: 320,
  height: 180
}, {
  // High Quality Thumbnail
  name: 'mqdefault',
  width: 480,
  height: 360
}];

/**
 * Get Youtube thumbnail image url with size that fits required `width` and `height`
 * @param {string} url
 * @param {number} width
 * @param {number} [height]
 * @returns {string}
 */
export function resizeYoutubeThumbnail(url, width, height) {
  const thumbnailMatch = url.match(YOUTUBE_THUMBNAIL_PATTERN);
  if (!thumbnailMatch) {
    return url;
  }
  const currentThumbnailSizeName = thumbnailMatch[2];
  const resizedThumbnailSize = YOUTUBE_THUMBNAIL_SIZES.find(thumbnailSize => thumbnailSize.width >= width && (!height || thumbnailSize.height >= height));
  if (resizedThumbnailSize && resizedThumbnailSize.name !== currentThumbnailSizeName) {
    return url.replace(`${currentThumbnailSizeName}.jpg`, `${resizedThumbnailSize.name}.jpg`);
  }
  return url;
}
//# sourceMappingURL=resize-youtube-thumbnail.js.map